import React, { Component } from "react";
import "./Skills.css";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skills } from "../../portfolio";
import { Fade } from "react-reveal";
import EmbeddedImg from "./EmbeddedImg";
import IoTImg from "./IoTImg";
import SecurityImg from "./SecurityImg";
import FlyingDroneImg from "./FlyingDroneImg";
import DataScienceImg from "./DataScienceImg";

function GetSkillSvg(props) {
  if (props.fileName === "SecurityImg")
    return <SecurityImg theme={props.theme} />;
  else if (props.fileName === "IoTImg") return <IoTImg theme={props.theme} />;
  else if (props.fileName === "EmbeddedImg")
    return <EmbeddedImg theme={props.theme} />;
  else if (props.fileName === "FlyingDroneImg")
    return <FlyingDroneImg theme={props.theme} />;
  else if (props.fileName === "DataScienceImg")
    return <DataScienceImg theme={props.theme} />;
}

class SkillSection extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div>
        {skills.data.map((skill, i) => {
          return (
            <div key={i} className="skills-main-div">
              <Fade left duration={2000}>
                <div className="skills-image-div">
                  <GetSkillSvg fileName={skill.fileName} theme={theme} />
                </div>
              </Fade>

              <div className="skills-text-div">
                <Fade right duration={1000}>
                  <h1 className="skills-heading" style={{ color: theme.text }}>
                    {skill.title}
                  </h1>
                </Fade>
                <Fade right duration={1500}>
                  <SoftwareSkill logos={skill.softwareSkills} />
                </Fade>
                <Fade right duration={2000}>
                  <div>
                    {skill.skills.map((skillSentence, i) => {
                      return (
                        <p
                          key={i}
                          className="subTitle skills-text"
                          style={{ color: theme.secondaryText }}
                        >
                          {skillSentence}
                        </p>
                      );
                    })}
                  </div>
                </Fade>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SkillSection;
